import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Button, PageHeader, Plus } from '@opendate-app/setlist';
import PushList from './PushList';
import CountBadge from '../../shared/components/CountBadge';
const axios = require('axios').default;
import AsyncSelect from 'react-select/async';
import { mergeSelectStyles } from '../../../shared/darkSelectStyles';

import Popup from "reactjs-popup";
import { ToastContainer } from 'react-toastify';

var _ = require('lodash');
var debouncedFetchEstimatedNumberOfSends;

const canSubmitForm = (pushNotification, isSubmitting) => {
  return (
    pushNotification
      && pushNotification.venue_ownership_id
      && pushNotification.calendar_events.length > 0
      && pushNotification.message
      && pushNotification.message.length > 0
      && !isSubmitting
  );
}

const debouncedConfirmFetch = _.debounce((inputValue, callback, team, venueOwnershipId) => {
  new Promise(resolve => {
    axios.get('/teams/' + team.id + '/calendar_events/autocomplete', {
        params: {
          name: inputValue,
          venue_ownership_id: venueOwnershipId,
          confirm_only: true,
          only_future: false
        }
      })
      .then(function (response) {
        var options = response.data.map(function(data){
          return { value: data.id, label: data.name };
        });

        callback(options);
      })
  });
}, 250);

const modalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "840px",
  "padding": "15px"
}

const selectStyles = mergeSelectStyles({
  container: base => ({ ...base, zIndex: "999", fontSize: "16px" }),
  control: base => ({ ...base, border: "1px solid var(--od-c-e6e6e6, #e6e6e6)" }),
  placeholder: base => ({ ...base, color: "var(--od-c-495057, #495057)" })
});

const PushNotifications = ({
  csrfToken,
  team,
  currentUser,
  dataTableDataSource,
  reloadKey,
  searchedSearchTerm,
  pushNotification,
  fetchNewPushNotification,
  pushNotificationChanged,
  venueOwnerships,
  createPushNotification,
  isSubmitting,
  fetchEstimatedNumberOfSends,
  estimatedNumberOfSends,
  estimatedNumberOfSendsChanged,
  hasPushNotifications
}) => {
  const [totalCount, setTotalCount] = useState(0);
  const canManage = Boolean(currentUser.can_manage_push_notifications);
  const openNewPushNotification = () => fetchNewPushNotification(csrfToken, team);

  useEffect(() => {
    debouncedFetchEstimatedNumberOfSends = _.debounce((team, pushNotification) => {
      fetchEstimatedNumberOfSends(team, pushNotification);
    }, 250);
  }, []);

  return (
    <div>
      <ToastContainer icon={false} />
      <PageHeader
        title={(
          <span className="d-inline-flex align-items-center" style={{ gap: 8 }}>
            Push
            <CountBadge count={totalCount} />
          </span>
        )}
        actions={canManage ? (
          <Button variant="primary" icon={Plus} onClick={openNewPushNotification}>New Push Notification</Button>
        ) : null}
      />
      <PushList
        dataSource={dataTableDataSource}
        reloadKey={reloadKey}
        initialSearch={searchedSearchTerm}
        hasPushNotifications={hasPushNotifications}
        canManage={canManage}
        onCreate={openNewPushNotification}
        onTotalChange={setTotalCount}
      />
      <Popup
       open={Object.keys(pushNotification).length > 0}
       contentStyle={modalContentStyle}
       className={"popup-modal"}
       closeOnDocumentClick={false}
       onOpen={
         () => {
           estimatedNumberOfSendsChanged(0);
         }
       }
       onClose={() => pushNotificationChanged({})}
      >
        <div className="row popup-modal-container">
          <div className="col-12">
            <div className="row">
              <div className="col d-flex align-items-center">
                <p className="mb-0"
                   style={{"fontSize": "24px"}}>
                  <strong>New Push Notification</strong>
                </p>
              </div>
              <div className="col-xs-auto d-flex align-items-center"
                   style={{"paddingRight": "15px"}}>
                <a onClick={
                     (e) => {
                       e.preventDefault();
                       pushNotificationChanged({});
                     }
                   }
                   className="text-dark"
                   href="#">
                  <i className="fal fa-times" style={{"fontSize": "24px"}}></i>
                </a>
              </div>
            </div>
            <form onSubmit={
                    (e) => {
                      e.preventDefault();

                      if(!canSubmitForm(pushNotification, isSubmitting)){
                        return false;
                      }

                      createPushNotification(csrfToken, team, pushNotification);
                    }
                  }>
              <div className="row" style={{"marginTop": "28px"}}>
                <div className="col-12 col-md-6 col-lg-8">
                  <div className="form-group">
                    <label htmlFor={"push-notification-venue-ownership"}
                           className="text-muted mb-1"
                           style={{"fontSize": "14px"}}>
                      Venue
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <select className="form-control"
                            style={{"border": "1px solid var(--od-c-e6e6e6, #e6e6e6)"}}
                            onChange={
                              (e) => {
                                var updated = Object.assign({}, pushNotification, {
                                  venue_ownership_id: e.target.value,
                                  calendar_events: []
                                });

                                debouncedFetchEstimatedNumberOfSends(team, updated);
                                pushNotificationChanged(updated);
                              }
                            }
                            id={"push-notification-venue-ownership"}
                            value={pushNotification.venue_ownership_id || ""}>
                      <option value="" disabled>Select venue</option>
                      {venueOwnerships.map((venueOwnership, index) =>
                        <option key={index} value={venueOwnership.id}>
                          {venueOwnership.venueable.name}
                        </option>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-8">
                  <div className="form-group">
                    <label htmlFor={"push-notification-confirm"}
                           className="text-muted mb-1"
                           style={{"fontSize": "14px"}}>
                      Events
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <AsyncSelect isMulti={true}
                                 cacheOptions={false}
                                 placeholder={"Enter an event name..."}
                                 isClearable={true}
                                 styles={selectStyles}
                                 isDisabled={!pushNotification.venue_ownership_id}
                                 menuPortalTarget={document.querySelector('body')}
                                 defaultOptions={false}
                                 id="push-notification-confirm"
                                 onChange={
                                   (option) => {
                                     var updated = {...pushNotification, calendar_events: (option || [])}

                                     debouncedFetchEstimatedNumberOfSends(team, updated);
                                     pushNotificationChanged(updated);
                                   }
                                 }
                                 value={pushNotification.calendar_events || ""}
                                 loadOptions={
                                   (inputValue, callback) => {
                                     return debouncedConfirmFetch(inputValue, callback, team, pushNotification.venue_ownership_id);
                                   }
                                 } />
                    <p className="mb-0 small text-muted">
                      {estimatedNumberOfSends.toLocaleString("en-US")} device(s)
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-8">
                  <div className="form-group">
                    <label htmlFor={"push-notification-subtitle"}
                           className="text-muted mb-1"
                           style={{"fontSize": "14px"}}>
                      Subtitle
                    </label>
                    <input text="email"
                           className="form-control"
                           style={{"border": "1px solid var(--od-c-e6e6e6, #e6e6e6)"}}
                           value={pushNotification.subtitle || ""}
                           onChange={
                             (e) => {
                               var updated = Object.assign({}, pushNotification, {
                                 subtitle: e.target.value
                               });

                               pushNotificationChanged(updated);
                             }
                           }
                           id="push-notification-subtitle" />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor={"push-notification-message"}
                       className="text-muted mb-1"
                       style={{"fontSize": "14px"}}>
                  Message
                  <span className="text-danger">&nbsp;*</span>
                </label>
                <textarea className="form-control"
                          style={{"border": "1px solid var(--od-c-e6e6e6, #e6e6e6)"}}
                          value={pushNotification.message || ""}
                          onChange={
                            (e) => {
                              var updated = Object.assign({}, pushNotification, {
                                message: e.target.value
                              });

                              pushNotificationChanged(updated);
                            }
                          }
                          id="push-notification-message"
                          rows="3">
                </textarea>
              </div>
              <div className="row mt-3">
                <div className="col-12 text-right">
                  <button type="submit"
                          disabled={!canSubmitForm(pushNotification, isSubmitting)}
                          className="btn btn-primary">
                    {isSubmitting ? (
                      <React.Fragment>
                        <img src="/uploading-loading.gif"
                             className="mr-1"
                             style={{width: "16px"}} />
                        <strong>Sending...</strong>
                      </React.Fragment>
                    ) : (
                      <strong>Send</strong>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  )
};

PushNotifications.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  reloadKey: PropTypes.number,
  searchedSearchTerm: PropTypes.string,
  pushNotification: PropTypes.object,
  fetchNewPushNotification: PropTypes.func.isRequired,
  pushNotificationChanged: PropTypes.func.isRequired,
  venueOwnerships: PropTypes.array,
  createPushNotification: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  fetchEstimatedNumberOfSends: PropTypes.func.isRequired,
  estimatedNumberOfSends: PropTypes.number,
  estimatedNumberOfSendsChanged: PropTypes.func.isRequired,
  hasPushNotifications: PropTypes.bool.isRequired,
};

PushNotifications.defaultProps = { reloadKey: 0 };

export default PushNotifications;
